export default __webpack_public_path__ + "static/media/paymentPageThumbnail.9fd08399.png";